import {Col, Row} from "antd";
import styled from "styled-components";

export const WalletSummaryContainer = styled(Row)`
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
`;

// Başlıklar kolon genişliğine sığmayıp ikonları alt satıra düşürmesin diye
// geniş ekranlarda kolonlar kalan boşluğu paylaşacak şekilde esneyebilir
export const StatisticCol = styled(Col)`
    && {
        @media (min-width: 992px) {
            flex: 1 1 0;
            max-width: none;
        }
    }
`;

// Başlık ve yanındaki ikon her zaman aynı satırda ve aynı hizada dursun
export const StatisticTitle = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
    min-height: 22px;

    .anticon,
    .ant-btn {
        flex-shrink: 0;
    }
`;
